$(document).ready(function(){
    
    /*
    $(window).scroll(function() {    
        // find the id with class 'active' and remove it
        $(".site-header").addClass("scrolling");
        // get the amount the window has scrolled
        //var scroll = $(window).scrollTop();
        // add the 'active' class to the correct id based on the scroll amount
        //if (scroll <= 500) {
            //$("#myCart").addClass("active");
        //}
    });
    */

    $('#mobile-filter-toggle').click(function(e){
        $('#listing-form .property-filters').fadeToggle('fast');
    });
    $('#filter-close').click(function(e){
        $('#listing-form .property-filters').fadeToggle('fast');
    });

    
    
    $('#sort-dropdown a').click(function(e){ 
        e.preventDefault();
        var sortType = $(this).data('sort-type');
        var sortText = $(this).data('sort-title');
        $('#sort-dropdown a').removeClass('active');
        $(this).addClass('active');
        $('#sort-button').html(sortText);
    });

    $('#sort-results').on('change', function(e) {  
        e.preventDefault();
        var sortType = this.value;
        $('#listing-form').submit(); 
    });

    $('#search-submit').click(function(e) {
        //e.preventDefault();
        // submit form
        $('#listing-form').submit(); 
    });
    $('#listing-form').keypress((e) => {
  
        // Enter key corresponds to number 13
        if (e.which === 13) {
            $('#listing-form').submit(); 
        }
    })

// State Filter
    $('#state-filter .filter-item').click(function(e) {
        //e.preventDefault();
        var $checkboxes = $('#state-filter input[type="checkbox"]');
        var count = $checkboxes.filter(':checked').length;
        if(count > 0) {
            $('#state-button span').text(count);
            $('#state-button span').addClass('on');
        }
        else {
            $('#state-button span').text('');
            $('#state-button span').removeClass('on');
        }
        // submit form
        $('#listing-form').submit(); 
    });

// County Filter
    $('#county-filter .filter-item').click(function(e) {
        //e.preventDefault();
        var $checkboxes = $('#county-filter input[type="checkbox"]');
        var count = $checkboxes.filter(':checked').length;
        if(count > 0) {
            $('#county-button span').text(count);
            $('#county-button span').addClass('on');
        }
        else {
            $('#county-button span').text('');
            $('#county-button span').removeClass('on');
        }
        // submit form
        $('#listing-form').submit(); 
    });

// Type Filter
    $('#type-filter .filter-item').click(function(e) {
        //e.preventDefault();
        var $checkboxes = $('#type-filter input[type="checkbox"]');
        var count = $checkboxes.filter(':checked').length;
        if(count > 0) {
            $('#type-button span').text(count);
            $('#type-button span').addClass('on');
        }
        else {
            $('#type-button span').text('');
            $('#type-button span').removeClass('on');
        }
        // submit form
        $('#listing-form').submit(); 
    });

// Status Filter
    $('#status-filter .filter-item').click(function(e) {
        //e.preventDefault();
        var $checkboxes = $('#status-filter input[type="checkbox"]');
        var count = $checkboxes.filter(':checked').length;
        if(count > 0) {
            $('#status-button span').text(count);
            $('#status-button span').addClass('on');
        }
        else {
            $('#status-button span').text('');
            $('#status-button span').removeClass('on');
        }

        $("input[name='propertystatus']").each( function () {
            if($(this).prop('checked') == true){
                if( $(this).val() === 'sold' ) {
                    $('#sort-select').hide();
                }
                else {
                    $('#sort-select').show();
                }
                //console.log( $(this).val() );
            }
            else {
                $('#sort-select').show();
            }
        });

        // hide sort if SOLD


        // submit form
        $('#listing-form').submit(); 
    });

/*
    $('.filter-item').click(function(e) {
        //e.preventDefault();
        console.log('here');
        $(this).closest('.dropdown').find('.dropdown-toggle').val('luke');

        // submit form
        $('#listing-form').submit(); 
    });
*/

// Acre Filter  */
    $('#acres-filter .filter-apply').click(function(e) {
        //e.preventDefault();
        
        var min = $('#acres-filter #min-acres').val();
        var max = $('#acres-filter #max-acres').val();

        // change text
        $('#acres-button').text(min + " - " + max + " acres");

        // submit form
        $('#listing-form').submit(); 
    });

// Price Filter  */
    $('#price-filter .filter-apply').click(function(e) {
        //e.preventDefault();
        
        var min = $('#price-filter #min-price').val();
        var max = $('#price-filter #max-price').val();

        // customize text display for high values
        var newmin = 0;
        var newmax = 0;

        if(min > 1000000) {
            newmin = (min/1000000) + "M";
        }
        else if(min > 1000) {
            newmin = (min/1000) + "K";
        }
        else {
            newmin = min;
        }

        if(max > 1000000) {
            newmax = (max/1000000) + "M";
        }
        else if(max > 1000) {
            newmax = (max/1000) + "K";
        }
        else {
            newmax = max;
        }

        // change text
        $('#price-button').text("$" + newmin + " - $" + newmax);

        // submit form
        $('#listing-form').submit(); 
    });

    
    /* On form submit, use filters */
    $("#listing-form").submit(function(e) {
        
        // Hide sold pagination when filtering
        $('#listings-pagination').hide();

        e.preventDefault();
        var $form = $(this).serializeArray();

        // update property cards
        $.ajax({
            url:  "/wp-admin/admin-ajax.php",
            type: 'GET',
            //dataType: "json",
            data: {
                action: 'property_filter',
                form: $form
            },
            success: function(data) {
                //console.log(data);
                //var dataInfo = JSON.parse(data);
                //console.log(dataInfo);
                $('#property-cards .card-area').html(data);
            },
            error: function(jqXHR, textStatus, errorThrown) {
                //console.log(jqXHR, textStatus, errorThrown);
            }
        });
        
        // update property map
        $.ajax({
            url:  "/wp-admin/admin-ajax.php",
            type: 'GET',
            //dataType: "json",
            data: {
                action: 'property_map_filter',
                form: $form
            },
            success: function(data) {
                //console.log(data);
                //var dataInfo = JSON.parse(data);
                //console.log(dataInfo);
                $('#property-map .map-area').html(data);
            },
            error: function(jqXHR, textStatus, errorThrown) {
                //console.log(jqXHR, textStatus, errorThrown);
            }
        });
        
        $.ajax({
            url:  "/wp-admin/admin-ajax.php",
            type: 'GET',
            dataType: "json",
            data: {
                action: 'property_filter_stats',
                form: $form
            },
            success: function(data) {
                //console.log(data);
                var dataInfo = JSON.parse(data);
                //console.log(dataInfo);

                $('.property-filter-info .matches #item_count').html(dataInfo.text);
            },
            error: function(jqXHR, textStatus, errorThrown) {
                //console.log(jqXHR, textStatus, errorThrown);
            }
        });
        

    });


});